import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';
import {matchErrors} from "../../common/util/errorResolver";
import { getLocale } from '../basicLocales';
import { ERROR_OK, ERROR_PERMANENT, ERROR_RESOLVE_BY_CUSTOMER, ERROR_RESOLVE_BY_DATIVERY, ERROR_RESOLVE_BY_PRODUCER, ERROR_TEMPORARY, ERROR_UNKNOWN } from '../../common/model-api/ChannelErrorDefType';
import config from '../../common/config';
import SafeHTML from '../fw/SafeHTML.react';
import urlMapping from "../app/URLMapping";
import { Link } from 'react-router';
import ChannelIcon from '../channel-defs/ChannelIcon.react';

export default class ChannelErrorBox extends React.Component {

    static propTypes = {
		accordion: PropTypes.bool,
		channelDef: PropTypes.object,
        channelErrorDef: PropTypes.object.isRequired,
		channelErrorMessages: PropTypes.array,
		children: PropTypes.node,
		additionalData: PropTypes.object,
    };

    constructor() {
        super();
		this.state = {
			isOpen: false
		};
    }

    render() {
		let channelErrorDef = this.props.channelErrorDef;
		let channelErrorMessages = this.props.channelErrorMessages;

		if (!channelErrorDef) {
			if (channelErrorMessages && channelErrorMessages.length > 0) {
				let realTitle = <FormattedMessage defaultMessage="Unclassified error" id="channelError.unclassifiedError" />;
				let errorType = <FormattedMessage 	defaultMessage="We have not classified this error yet. Please analyse error or contact {app} support. " id="channelError.unclassifiedErrorTitle" values={{app: config.PRODUCT_NAME}}/>;
				let realDescription = channelErrorMessages.join("\n");
				return (
					<div className="channelError">
					<div className="alert alert-danger" role="alert">
						<div className="glyphicon glyphicon-exclamation-sign"></div>
						<div>
								<div>
									<h3>{realTitle}</h3><p><SafeHTML value={realDescription} /></p>
									<div className='channelErrorType'>{errorType}</div>
									{this.props.children}
								</div>
						</div>
					</div>
				</div>
				);
			}
		}

		let {realTitle, realDescription, realResolution} = matchErrors([channelErrorDef], channelErrorMessages, getLocale(), channelErrorDef);

		let resolvableBy = channelErrorDef.resolvableBy;
		let errorType = channelErrorDef.type;
		if (errorType === ERROR_OK) {
			errorType = null;
		} else if (errorType === ERROR_PERMANENT || errorType === ERROR_UNKNOWN || !errorType) {
			if (resolvableBy === ERROR_RESOLVE_BY_CUSTOMER) {
				errorType = <FormattedMessage defaultMessage="Customer intervention is required." id="channelError.permanentCustomer" />;
			} else if (resolvableBy === ERROR_RESOLVE_BY_DATIVERY) {
				errorType = <FormattedMessage defaultMessage="{app} intervention is required." id="channelError.permanentDativery" values={{app: config.PRODUCT_NAME}}/>;

			} else if (resolvableBy === ERROR_RESOLVE_BY_PRODUCER) {
				errorType = <FormattedMessage defaultMessage="The intervention of the {app} system manufacturer is required." id="channelError.permanentProducer" values={{app: this.props.channelDef.name}}/>;
			}
		} else if (errorType === ERROR_TEMPORARY) {
			if (resolvableBy === ERROR_RESOLVE_BY_CUSTOMER) {
				errorType = <FormattedMessage 	defaultMessage="This is a temporary error that should most likely be resolved later by retrying the request." id="channelError.temporaryCustomer" />;
			} else if (resolvableBy === ERROR_RESOLVE_BY_DATIVERY) {
					errorType = <FormattedMessage 	defaultMessage="This is a temporary error in {app} that should most likely be resolved later by retrying the request." id="channelError.temporaryDativery"  values={{app: config.PRODUCT_NAME}} />;
			} else if (resolvableBy === ERROR_RESOLVE_BY_PRODUCER) {
				errorType = <FormattedMessage 	defaultMessage="This is a temporary error in {app} that should most likely be resolved later by retrying the request." id="channelError.temporaryProducer" values={{app: this.props.channelDef.name}} />;
			}
		}

		let renderCount = this.props.accordion && this.props.additionalData.count > 1;

        return (
			<div className="channelError" style={{ position: 'relative' }}>
				{renderCount && <div style={{
					position: 'absolute',
					top: '1em',
					right: '1em',
					fontSize: '1em',
                    color: '#888',
                }}>
					<div style={{transform: this.state?.isOpen ? 'rotate(45deg)' : 'rotate(0deg)'}}>
												<span className="fa fa-chevron-down fa-lg"></span>
											</div>
                </div>}
				<div className="alert alert-danger" role="alert">
					{!this.props.accordion ? <div className="glyphicon glyphicon-exclamation-sign"></div> : <div style={{marginRight: '1em'}} ><ChannelIcon channelDef={this.props.channelDef} size={54} /></div>}
					<div>
							<div key={channelErrorDef.id}>
								{this.props.accordion ? <details onClick={() => this.setState({ isOpen: !this.state?.isOpen })}>
									<summary style={{cursor: "pointer"}}>
										<div style={{display: 'flex', justifyContent: 'space-between'}}>
											<h3 style={{marginBottom: '5px'}}>{realTitle}</h3>

										</div>

										<ul style={{fontSize: '1em', color: '#888', padding: 0, margin: 0, listStyleType: 'none'}}>
											{this.props.additionalData?.flow && <li>
												{this.props.additionalData?.organisationId && <Link to={urlMapping.getUrl('organisations', 'view', { id: this.props.additionalData.organisationId })}>
													{this.props.additionalData.organisationName}
												</Link>}
												{this.props.additionalData?.organisationId && this.props.additionalData?.flow?.id && ' / '}
												{this.props.additionalData?.flow?.id && <Link to={urlMapping.getUrl('flows', 'view', { id: this.props.additionalData.flow.id, organisation_id: this.props.additionalData.flow.organisation_id })}>
													{this.props.additionalData.flow.flowName}
												</Link>}
											</li>}
											<li>Poslední výskyt: {this.props.additionalData.lastErrorTransferAt}</li>
										</ul>
										</summary>
										<p style={{margin: '1.5em 0'}}>{"	"}</p>
									<p><SafeHTML value={realDescription} /></p> {realResolution ? <span><FormattedMessage defaultMessage="Possible resolution:" id="channelError.possibleResolution" /><br/><SafeHTML value={realResolution} /></span> : null}
									<div className='channelErrorType'>{errorType}</div>
									{this.props.children}
								</details> : <div>
									<h3>{realTitle}</h3>
									<p><SafeHTML value={realDescription} /></p> {realResolution ? <span><FormattedMessage defaultMessage="Possible resolution:" id="channelError.possibleResolution" /><br/><SafeHTML value={realResolution} /></span> : null}
									<div className='channelErrorType'>{errorType}</div>
									{this.props.children}
								</div>}
							</div>
					</div>
				</div>
			</div>
        );
    }
}
